import React, {
  useState,
  useEffect,
  useCallback,
  useRef,
  useMemo,
} from "react";
import "bootstrap/dist/css/bootstrap.css";
import { Container } from "reactstrap";
import { getCompany, getPersonById } from "api/AccountsApi";
import { getAudiencesByIdCount, getAudiencesById } from "api/AudienceApi";
import { setAudienceLoading } from "ReduxStore/Slices/audienceSlice";
import { useDispatch, useSelector } from "react-redux";
import Table from "../Table";
import { useHistory } from "react-router-dom";
import { exportAudience } from 'api/ExportApi'
import { toast } from 'react-toastify';
import Tooltip from "react-bootstrap/Tooltip";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import {POST} from 'api/API'
const ListAudience = (props) => {
  const [dataApi, setDataApi] = useState([]);
  const [companyName, setCompanyName] = useState("");
  const [audienceCount, setaudienceCount] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [pageIndex, setPageIndex] = useState(0);
  const [isAdmin, setIsAdmin] = useState(false);
  const [audienceReady , setAudienceReady] = useState(true);
  const [isValid , setIsValid] = useState(true);

  const dispatch = useDispatch();
  const history = useHistory();
  const { audienceLoading } = useSelector((state) => state.audienceSetter);
  useEffect(() => {
    dispatch(setAudienceLoading(true));
    getCompany()
      .then((data) => {
        setCompanyName(data.name);
      })
      .catch((e) => { });
  }, []);

  const fetchData = useCallback(
    async ({ pageSize, pageIndex }) => {
      dispatch(setAudienceLoading(true));
      const startRow = pageSize * pageIndex;
      const endRow = startRow + pageSize;
      setPageIndex(pageIndex);

      await getAudiencesById(
        sessionStorage.getItem("audience_list_id"),
        pageSize,
        startRow
      )
        .then((data) => {
          setIsValid(data.isValid)
          if(data.ready == false){
            setAudienceReady(false)
            dispatch(setAudienceLoading(false));

          }else{
            setDataApi(data.persons);
             
            getAudiencesByIdCount(sessionStorage.getItem("audience_list_id"))
              .then((data) => {
                setPageCount(Math.ceil(data.count / pageSize));
                setaudienceCount(data.count);
                dispatch(setAudienceLoading(false));

              })
              .catch((e) => {

                toast.error(e.response.data.message || "Something went wrong. Please try again later")
                dispatch(setAudienceLoading(false));

              });
          }
        })
        .catch((e) => { 
          toast.error(e.response.data.message || "Something went wrong. Please try again later")

          dispatch(setAudienceLoading(false));

        });
    },
    [dataApi]
  );

  const getPersonData = (e) => {
    getPersonById(e.id)
      .then((person) => {
        if (person.tags) {

          let tagsObjs = person.tags;
          let tagArray = [];
          tagsObjs.forEach((o) => {
            tagArray.push(o.tag);
          });
          person.tagList = tagArray;
          person.tags = tagArray;
        }

        person.back = window.location.pathname;

        history.push(`/admin/contact/details?id=${person.id}`, person);
      })
      .catch((e) => { });
  };
  const columns = useMemo(
    () => [
      {
        Header: "First Name",
        accessor: "firstName",
      },
      {
        Header: "Last Name",
        accessor: "lastName",
      },
      {
        Header: "Email",
        accessor: "email",
      },
      {
        Header: "ID",
        accessor: "id",
      },
      {
        Header: "Phone",
        accessor: "phone",
      },
      {
        Header: "",
        accessor: "name_2",
        Cell: ({ cell }) => (

          (
            <a
              onClick={() => getPersonData(cell.row.original)}
              style={{
                color: "#2C40CE",
                cursor: "pointer",
                width: "100%",
                textAlign: "center",
              }}
            >
              Details
            </a>
          )
        ),
      },
    ],
    []
  );
  const data = useMemo(() => dataApi, [dataApi]);
  function updateRole() {
    let t = localStorage.getItem('role');
    setIsAdmin(t === 'admin');
  }
  useEffect(() => {
    updateRole()
    window.addEventListener('storage', updateRole)

  }, [])

  return (
    <Container>
      <div className="page_heading">
        <h2>Audience List</h2>
        <button
          className="btn btn-sm"
          style={{ color: "#114169" }}
          onClick={() => history.goBack()}
        >{`< Back`}</button>
        <div className="export" >

        </div>
        <div>
          <div style={{ display: "flex",justifyContent:'space-between'  }}>
            <p>{sessionStorage.getItem('audience_list_name') || ''}</p>
            <div style={{display: 'flex', alignItems:"flex-end"}}>
            {isAdmin &&<input
              onClick={(e) => exportAudience(sessionStorage.getItem("audience_list_id"))}
              type="submit"
              name="Save"
              // style={{
              //   margin_top: "2v",
              //   cursor: "pointer",
              //   borderRadius: "6px",
              //   padding: "0px",
              //   minWidth: "90px",
              //   fontSize: "13px",
              //   margin: "0 12px",
              //   height: "32px"
              // }}
              className="add__stage lg_btn primary"
              value="Export"
            />}
                       <OverlayTrigger
              delay={{ hide: 50, show: 50 }}
              placement="top"
              key="top"
              overlay={(props) => (
                <Tooltip id="tooltip-top" {...props}>
                {isValid? "Audience is UpToDate" :"Audience is not UpToDate. Please Refresh"}
                </Tooltip>
              )}
            >
                   <input
              onClick={()=>{
                POST(`personal/audiences/${sessionStorage.getItem("audience_list_id")}/rebuild`,{}).then((data)=>{
                  toast.success("Audience is being Refreshed. Please wait for 5-10 minutes")
                }).catch((e)=>{
                  toast.error(e.response.data.message || "Something went wrong. Please try again later")

                })
              }}
              type="submit"
              name="Save"
              className={!isValid?"ybtn add__stage lg_btn":"add__stage lg_btn primary"}
              value="Refresh"
            />  
            </OverlayTrigger>

            </div>
          </div>
          <p className="sm d-flex align-items-center">
            You have{" "}
            {audienceCount > 1
              ? `${audienceCount} contacts`
              : `${audienceCount} contact`}{" "}
            in this Audience
          </p>
        </div>
      </div>
      <div></div>
     {audienceReady &&<div className="dataTableOuter">
        <div className="table-flter rdt_Pagination d-flex align-items-end">
          <span className="inline-label ml-auto">
            Page No. {pageIndex + 1} of {pageCount}
          </span>
        </div>
        {
          <Table
            columns={columns}
            data={data}
            fetchData={fetchData}
            pageCount={pageCount}
            loading={audienceLoading}
          ></Table>
        }
      </div>}
      {!audienceReady && <div 
      style={{
        padding:"30px",
        fontSize:"20px",
        fontFamily:"DM sans"
      }}
      >This audience can't be displayed now. Please try again after 10 minutes.</div>}
    </Container>
  );
};

export default ListAudience;
